import React from 'react';
import './roomSuggestion.css'; // You'll need to create this CSS file

const RoomSuggestion = () => {
  // Sample room data (replace with your actual data)
  const rooms = [
    {
      id: 1,
      name: "Deluxe Room - 1 Double Bed 25SQM",
      price: 3500,
      features: [
        "Room with Free Cancellation",
        "Breakfast only",
        "Free Wi-Fi",
        "Non-smoking",
        "Air-conditioning"
      ],
      image: "https://dq5r178u4t83b.cloudfront.net/wp-content/uploads/sites/125/2020/06/15182916/Sofitel-Dubai-Wafi-Luxury-Room-Bedroom-Skyline-View-Image1_WEB.jpg"
    },
    {
      id: 2,
      name: "Premium Room - 1 Double Bed 30SQM",
      price: 4500,
      features: [
        "Room with Free Cancellation",
        "Breakfast only",
        "Free Wi-Fi",
        "Non-smoking",
        "Air-conditioning"
      ],
      image: "https://dq5r178u4t83b.cloudfront.net/wp-content/uploads/sites/125/2020/06/15182916/Sofitel-Dubai-Wafi-Luxury-Room-Bedroom-Skyline-View-Image1_WEB.jpg"
    },
    {
      id: 3,
      name: "Suite - 2 Double Bed 50SQM",
      price: 7200,
      features: [
        "Room with Free Cancellation",
        "Breakfast included",
        "Free Wi-Fi",
        "Non-smoking",
        "Air-conditioning"
      ],
      image: "https://dq5r178u4t83b.cloudfront.net/wp-content/uploads/sites/125/2020/06/15182916/Sofitel-Dubai-Wafi-Luxury-Room-Bedroom-Skyline-View-Image1_WEB.jpg"}
  ];

  return (
    <div className="suggestion-section">
      <h2 className="suggestion-title">3 Room Types <span className="filter-link">Free Cancellation</span></h2>
      
      <div className="rooms-container">
        {rooms.map(room => (
          <div key={room.id} className="room-card">
            <img src={room.image} alt={room.name} className="room-image" />
            <div className="room-details">
              <h3 className="room-name">{room.name}</h3>
              <ul className="room-features">
                {room.features.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
              <div className="room-price">
                <span className="price-value">₹ {room.price.toLocaleString()}</span>
                <span className="price-text"> Taxes per night</span>
              </div>
              <button className="select-button">SELECT ROOM</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RoomSuggestion;